"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment, useClient } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { prefetchCollectionItemsPage } from "@/app/[locale]/[currency]/[persona]/(full-immersive)/collection/[collectionSlug]/[heroHeaderView]/items/[userPreferences]/prefetch";
import { DropStatus } from "@/components/collection/drops/constants";
import { getDropStatus } from "@/components/collection/drops/utils";
import { getCollectionOverviewUrl, getCollectionUrlBySlug } from "@/components/collection/utils";
import { trackCollectionPageNavigation } from "@/lib/performance";
import { CollectionLinkFragment } from "./CollectionLink.fragment";
function isFragmentProps(props) {
  return !props.href;
}
function getProps(props) {
  if (isFragmentProps(props)) {
    const {
      collection,
      ...rest
    } = props;
    const {
      slug,
      ...data
    } = readFragment(CollectionLinkFragment, collection);
    if (data.__typename === "Collection") {
      const dropStatus = getDropStatus(data);
      if (dropStatus === DropStatus.MINTING || dropStatus === DropStatus.MINTING_SOON) {
        const href = getCollectionOverviewUrl(slug);
        return {
          href,
          ...rest
        };
      }
    }
    const href = getCollectionUrlBySlug(slug);
    return {
      href,
      ...rest
    };
  }
  return props;
}
function getCollectionSlug(href) {
  const parts = href.split("/");
  return parts.at(-1);
}
export function CollectionLink(props) {
  const $ = _c(18);
  let t0;
  if ($[0] !== props) {
    t0 = getProps(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let href;
  let onPointerDown;
  let rest;
  let t1;
  if ($[2] !== t0) {
    ({
      href,
      variant: t1,
      onPointerDown,
      ...rest
    } = t0);
    $[2] = t0;
    $[3] = href;
    $[4] = onPointerDown;
    $[5] = rest;
    $[6] = t1;
  } else {
    href = $[3];
    onPointerDown = $[4];
    rest = $[5];
    t1 = $[6];
  }
  const variant = t1 === undefined ? "unstyled" : t1;
  const client = useClient();
  let t2;
  if ($[7] !== client || $[8] !== href) {
    t2 = () => {
      const collectionSlug = getCollectionSlug(href);
      if (collectionSlug) {
        prefetchCollectionItemsPage(collectionSlug, client);
      }
    };
    $[7] = client;
    $[8] = href;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handlePrefetch = t2;
  let t3;
  if ($[10] !== handlePrefetch || $[11] !== onPointerDown) {
    t3 = event => {
      handlePrefetch();
      onPointerDown?.(event);
    };
    $[10] = handlePrefetch;
    $[11] = onPointerDown;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== href || $[14] !== rest || $[15] !== t3 || $[16] !== variant) {
    t4 = <Link href={href} onNavigationCompleted={trackCollectionPageNavigation} onPointerDown={t3} prefetch="onHover" variant={variant} {...rest} />;
    $[13] = href;
    $[14] = rest;
    $[15] = t3;
    $[16] = variant;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}